export default [
  { 
    id: 13,
    name: "Sprechstunde",
    startDate: "2025-06-27",
    endDate: "2025-06-27",
    startTime: "09:00",
    endTime: "10:00",
    location: "online (Zoom)",
    isOnline: true,
    description: "Kostenlose Online-Sprechstunde für kurze Fragen zu (Ab-)Stillen, Babyschlaf und Beikost. Oder einfach nur zum Kennenlernen von Maikes Familienbegleitung. Teilnahmelink auf Anfrage.",
    eventUrlRelative: "/kontakt/",
    badge: "kostenlos",
    info: "Kostenlose Online-Sprechstunde für kurze Fragen zu (Ab-)Stillen, Babyschlaf und Beikost. Oder einfach nur zum Kennenlernen. Teilnahmelink auf Anfrage.",
    price: "0" 
  },
  { 
    id: 24,
    name: "Papa-Krabbelgruppe",
    startDate: "2025-07-09",
    endDate: "2025-08-06",
    startTime: "16:00",
    endTime: "17:30",
    location: "KO-Metternich",
    isOnline: false,
    description: "Entdecke die Krabbelgruppe für Väter in Koblenz! 5 Termine, fachlicher Input & Austausch für Papas mit Babys im 1. Lebensjahr. Jetzt anmelden!",
    eventUrlRelative: "/papa-krabbelgruppe/",
    info: "Serie aus 5 Terminen. Für Papas mit Babies im ersten Lebensjahr.",
    price: "40" 
  },
  { 
    id: 14,
    name: "Stillvorbereitungskurs",
    startDate: "2025-07-10",
    endDate: "2025-07-10",
    startTime: "19:00",
    endTime: "21:00",
    location: "KO-Metternich",
    isOnline: false,
    description: "Ein Kurs für werdende Eltern aus Koblenz und Umgebung mit Fokus auf Stillvorbereitung.",
    eventUrlRelative: "/stillvorbereitung/" 
  },
  { 
    id: 15,
    name: "Sprechstunde",
    startDate: "2025-07-21",
    endDate: "2025-07-21",
    startTime: "11:00",
    endTime: "12:00",
    location: "online (Zoom)",
    isOnline: true,
    description: "Kostenlose Online-Sprechstunde für kurze Fragen zu (Ab-)Stillen, Babyschlaf und Beikost. Oder einfach nur zum Kennenlernen von Maikes Familienbegleitung. Teilnahmelink auf Anfrage.",
    eventUrlRelative: "/kontakt/",
    badge: "kostenlos",
    info: "Kostenlose Online-Sprechstunde für kurze Fragen zu (Ab-)Stillen, Babyschlaf und Beikost. Oder einfach nur zum Kennenlernen. Teilnahmelink auf Anfrage.",
    price: "0" 
  },
  { 
    id: 16,
    name: "Schlafworkshop",
    startDate: "2025-07-25",
    endDate: "2025-07-25",
    startTime: "13:30",
    endTime: "15:30",
    location: "online (Zoom)",
    isOnline: true,
    description: "Ein Online-Kurs für (werdende) Eltern aus Koblenz und Umgebung mit Fokus auf den Babyschlaf.",
    eventUrlRelative: "/schlafworkshop/" 
  },
  { 
    id: 17,
    name: "Beikostworkshop",
    startDate: "2025-07-26",
    endDate: "2025-07-26",
    startTime: "09:30",
    endTime: "11:00",
    location: "online (Zoom)",
    isOnline: true,
    description: "Ein Online-Kurs für junge Eltern aus Koblenz und Umgebung mit Fokus auf den Beikoststart.",
    eventUrlRelative: "/beikostworkshop/" 
  },
  { 
    id: 18,
    name: "Stillvorbereitungskurs",
    startDate: "2025-07-28",
    endDate: "2025-07-28",
    startTime: "19:00",
    endTime: "21:00",
    location: "online (Zoom)",
    isOnline: true,
    description: "Ein Kurs für werdende Eltern mit Fokus auf Stillvorbereitung.",
    eventUrlRelative: "/stillvorbereitung/" 
  },
  { 
    id: 19,
    name: "Abstillworkshop",
    startDate: "2025-08-11",
    endDate: "2025-08-11",
    startTime: "09:30",
    endTime: "11:30",
    location: "online (Zoom)",
    isOnline: true,
    description: "Ein Kurs für Eltern mit Fokus aufs Abstillen.",
    eventUrlRelative: "/", 
    info: "Mehr Infos folgen bald. Seid gespannt."
  },
  { 
    id: 20,
    name: "Beikostworkshop",
    startDate: "2025-08-12",
    endDate: "2025-08-12",
    startTime: "09:30",
    endTime: "11:00",
    location: "KO-Metternich",
    isOnline: false,
    description: "Ein Kurs für junge Eltern aus Koblenz und Umgebung mit Fokus auf den Beikoststart.",
    eventUrlRelative: "/beikostworkshop/" 
  },
  { 
    id: 21,
    name: "Sprechstunde",
    startDate: "2025-08-20",
    endDate: "2025-08-20",
    startTime: "20:00",
    endTime: "21:00",
    location: "online (Zoom)",
    isOnline: true,
    description: "Kostenlose Online-Sprechstunde für kurze Fragen zu (Ab-)Stillen, Babyschlaf und Beikost. Oder einfach nur zum Kennenlernen von Maikes Familienbegleitung. Teilnahmelink auf Anfrage.",
    eventUrlRelative: "/kontakt/",
    badge: "kostenlos",
    info: "Kostenlose Online-Sprechstunde für kurze Fragen zu (Ab-)Stillen, Babyschlaf und Beikost. Oder einfach nur zum Kennenlernen. Teilnahmelink auf Anfrage.",
    price: "0" 
  },
  { 
    id: 22,
    name: "Stillvorbereitungskurs",
    startDate: "2025-08-22",
    endDate: "2025-08-22",
    startTime: "19:00",
    endTime: "21:00",
    location: "online (Zoom)",
    isOnline: true,
    description: "Ein Kurs für werdende Eltern mit Fokus auf Stillvorbereitung.",
    eventUrlRelative: "/stillvorbereitung/" 
  },
  { 
    id: 23,
    name: "Schlafworkshop",
    startDate: "2025-08-27",
    endDate: "2025-08-27",
    startTime: "15:30",
    endTime: "17:30",
    location: "KO-Metternich",
    isOnline: false,
    description: "Ein Kurs für (werdende) Eltern aus Koblenz und Umgebung mit Fokus auf den Babyschlaf.",
    eventUrlRelative: "/schlafworkshop/" 
  }
];